import { fetcher } from "@/utils/api"
import { queryClient } from "pages/_app"

export const useMarkAllNotificationsAsRead = () => {
  return async () => {
    try {
      await fetcher("/notifications/v2", {
        method: "PATCH",
        body: JSON.stringify({ read: true }),
      })
      queryClient.invalidateQueries({
        queryKey: ["notifications"],
      })
    } catch (error) {
      console.log(error)
    }
  }
}
